import { FaClipboardCheck, FaCalendarAlt, FaUsers, FaChartBar, FaCheckCircle, FaTimesCircle, FaExclamationCircle, FaDownload, FaPlus, FaClock, FaEdit, FaSave, FaTimes } from "react-icons/fa";
import { useState } from "react";
import { useAuth } from "./AuthContext";

export default function Attendance() {
  const { user } = useAuth();
  const isAdmin = user?.isProfileAdmin || false;

  const [editingAttendance, setEditingAttendance] = useState(null); // { meetingId, memberId }
  const [editForm, setEditForm] = useState({ status: "", checkInTime: "", reason: "" });
  const [showAddMeeting, setShowAddMeeting] = useState(false);
  const [newMeetingForm, setNewMeetingForm] = useState({
    title: "",
    date: "",
    time: "",
    type: "General",
    quorumRequired: 20,
  });

  const [meetings, setMeetings] = useState([
    {
      id: 1,
      title: "Monthly Council Meeting",
      date: "2026-01-15",
      time: "10:00 AM",
      type: "General",
      quorumRequired: 20,
      totalMembers: 30,
      attendance: [
        { memberId: 1, name: "Josie Simm", status: "present", checkInTime: "09:58 AM" },
        { memberId: 2, name: "Mohammed Waseem Chaudry", status: "present", checkInTime: "10:02 AM" },
        { memberId: 3, name: "Karol Tolpa", status: "present", checkInTime: "10:00 AM" },
        { memberId: 4, name: "Anand Kant Das", status: "present", checkInTime: "10:05 AM" },
        { memberId: 5, name: "Eudora Okine", status: "absent", reason: "Sick leave" },
        { memberId: 6, name: "Shreekanth Nair", status: "late", checkInTime: "10:25 AM" },
        { memberId: 7, name: "Sabah Siddiqui", status: "present", checkInTime: "09:55 AM" },
        { memberId: 8, name: "Amnah Khan", status: "present", checkInTime: "10:03 AM" },
        { memberId: 9, name: "Abigail Cahill", status: "present", checkInTime: "10:01 AM" },
        { memberId: 10, name: "Valeriya Golovina", status: "excused", reason: "Conference" },
      ],
    },
    {
      id: 2,
      title: "Steering Committee Meeting",
      date: "2026-01-08",
      time: "2:00 PM",
      type: "Committee",
      quorumRequired: 5,
      totalMembers: 8,
      attendance: [
        { memberId: 1, name: "Josie Simm", status: "present", checkInTime: "02:00 PM" },
        { memberId: 2, name: "Mohammed Waseem Chaudry", status: "present", checkInTime: "01:58 PM" },
        { memberId: 3, name: "Karol Tolpa", status: "present", checkInTime: "02:02 PM" },
        { memberId: 4, name: "Anand Kant Das", status: "late", checkInTime: "02:15 PM" },
        { memberId: 5, name: "Eudora Okine", status: "present", checkInTime: "02:00 PM" },
        { memberId: 6, name: "Shreekanth Nair", status: "present", checkInTime: "01:59 PM" },
        { memberId: 7, name: "Sabah Siddiqui", status: "absent", reason: "Personal" },
        { memberId: 8, name: "Amnah Khan", status: "present", checkInTime: "02:01 PM" },
      ],
    },
    {
      id: 3,
      title: "Academic Staff Committee",
      date: "2026-01-04",
      time: "11:00 AM",
      type: "Committee",
      quorumRequired: 6,
      totalMembers: 12,
      attendance: [
        { memberId: 3, name: "Karol Tolpa", status: "present", checkInTime: "11:00 AM" },
        { memberId: 9, name: "Abigail Cahill", status: "present", checkInTime: "10:58 AM" },
        { memberId: 10, name: "Valeriya Golovina", status: "present", checkInTime: "11:02 AM" },
        { memberId: 11, name: "Ibrahim Chehade", status: "present", checkInTime: "11:00 AM" },
        { memberId: 12, name: "Samia Ahmed", status: "present", checkInTime: "10:59 AM" },
        { memberId: 13, name: "Wahib Mufid Salim", status: "absent", reason: "Teaching" },
      ],
    },
  ]);

  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [viewMode, setViewMode] = useState("list"); // list or detail

  // Edit functions
  const handleEditAttendance = (meetingId, member) => {
    setEditingAttendance({ meetingId, memberId: member.memberId });
    setEditForm({
      status: member.status,
      checkInTime: member.checkInTime || "",
      reason: member.reason || "",
    });
  };

  const handleSaveAttendance = () => {
    if (!editingAttendance) return;

    setMeetings(meetings.map(meeting => {
      if (meeting.id === editingAttendance.meetingId) {
        return {
          ...meeting,
          attendance: meeting.attendance.map(att => {
            if (att.memberId === editingAttendance.memberId) {
              return {
                ...att,
                status: editForm.status,
                checkInTime: editForm.checkInTime || undefined,
                reason: editForm.reason || undefined,
              };
            }
            return att;
          })
        };
      }
      return meeting;
    }));

    setEditingAttendance(null);
    setEditForm({ status: "", checkInTime: "", reason: "" });
  };

  const handleCancelEdit = () => {
    setEditingAttendance(null);
    setEditForm({ status: "", checkInTime: "", reason: "" });
  };

  const handleAddMeeting = () => {
    if (!newMeetingForm.title || !newMeetingForm.date || !newMeetingForm.time) {
      alert("Please fill in all required fields");
      return;
    }

    const newMeeting = {
      id: Math.max(...meetings.map(m => m.id)) + 1,
      ...newMeetingForm,
      totalMembers: 30,
      attendance: [], // Start with empty attendance
    };

    setMeetings([...meetings, newMeeting]);
    setShowAddMeeting(false);
    setNewMeetingForm({
      title: "",
      date: "",
      time: "",
      type: "General",
      quorumRequired: 20,
    });
  };

  const getStatusColor = (status) => {
    const colors = {
      present: "#48bb78",
      absent: "#f56565",
      excused: "#ed8936",
      late: "#f6ad55",
    };
    return colors[status] || "#a0aec0";
  };

  const getStatusIcon = (status) => {
    const icons = {
      present: <FaCheckCircle />,
      absent: <FaTimesCircle />,
      excused: <FaExclamationCircle />,
      late: <FaClock />,
    };
    return icons[status] || <FaExclamationCircle />;
  };

  const calculateAttendanceStats = (meeting) => {
    const stats = {
      present: meeting.attendance.filter(a => a.status === "present").length,
      absent: meeting.attendance.filter(a => a.status === "absent").length,
      excused: meeting.attendance.filter(a => a.status === "excused").length,
      late: meeting.attendance.filter(a => a.status === "late").length,
    };
    stats.total = meeting.attendance.length;
    stats.attendanceRate = Math.round((stats.present / stats.total) * 100);
    stats.quorumMet = stats.present >= meeting.quorumRequired;
    return stats;
  };

  const calculateMemberStats = () => {
    // Calculate overall attendance stats for each member
    const memberStats = {};
    
    meetings.forEach(meeting => {
      meeting.attendance.forEach(record => {
        if (!memberStats[record.memberId]) {
          memberStats[record.memberId] = {
            name: record.name,
            present: 0,
            absent: 0,
            excused: 0,
            late: 0,
            total: 0,
          };
        }
        memberStats[record.memberId][record.status]++;
        memberStats[record.memberId].total++;
      });
    });

    return Object.values(memberStats).map(stat => ({
      ...stat,
      attendanceRate: Math.round((stat.present / stat.total) * 100),
    })).sort((a, b) => b.attendanceRate - a.attendanceRate);
  };

  const memberStats = calculateMemberStats();

  const exportAttendanceReport = (meeting) => {
    const stats = calculateAttendanceStats(meeting);
    const csvContent = [
      ["Meeting Attendance Report"],
      [`Meeting: ${meeting.title}`],
      [`Date: ${new Date(meeting.date).toLocaleDateString()}`],
      [`Time: ${meeting.time}`],
      [""],
      ["Name", "Status", "Check-in Time", "Reason"],
      ...meeting.attendance.map(a => [
        a.name,
        a.status,
        a.checkInTime || "N/A",
        a.reason || "N/A"
      ]),
      [""],
      ["Summary"],
      [`Total Members: ${stats.total}`],
      [`Present: ${stats.present}`],
      [`Absent: ${stats.absent}`],
      [`Excused: ${stats.excused}`],
      [`Late: ${stats.late}`],
      [`Attendance Rate: ${stats.attendanceRate}%`],
      [`Quorum Met: ${stats.quorumMet ? "Yes" : "No"}`],
    ].map(row => row.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `attendance_${meeting.title.replace(/\s+/g, "_")}_${meeting.date}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // Access control - only admins can view attendance
  if (!isAdmin) {
    return (
      <div
        style={{
          padding: "40px",
          maxWidth: "800px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "60px 40px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <FaClipboardCheck
            style={{
              fontSize: "64px",
              color: "#cbd5e0",
              marginBottom: "20px",
            }}
          />
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#2d3748",
              marginBottom: "12px",
            }}
          >
            Access Restricted
          </h2>
          <p
            style={{
              color: "#718096",
              fontSize: "16px",
              lineHeight: "1.6",
              marginBottom: "24px",
            }}
          >
            Attendance tracking is only accessible to administrators.
            <br />
            Please contact a council administrator if you need access to attendance records.
          </p>
          <div
            style={{
              padding: "16px",
              background: "#f7fafc",
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
            }}
          >
            <div style={{ fontSize: "13px", color: "#718096", marginBottom: "8px" }}>
              <strong>Administrator Contacts:</strong>
            </div>
            <div style={{ fontSize: "13px", color: "#4a5568" }}>
              • Josie Simm (js9640@nyu.edu)
              <br />
              • Karen Sheils (ks5404@nyu.edu)
              <br />
              • Mahra Alblooshi (mxa5271@nyu.edu)
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "1400px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: "30px", display: "flex", justifyContent: "space-between", alignItems: "start" }}>
        <div>
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "700",
              color: "#2d3748",
              marginBottom: "8px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <FaClipboardCheck style={{ color: "#667eea" }} />
            Attendance Tracking
          </h1>
          <p style={{ color: "#718096", fontSize: "16px", margin: 0 }}>
            Monitor meeting attendance and participation rates
          </p>
        </div>
        <button
          onClick={() => setShowAddMeeting(true)}
          style={{
            padding: "12px 24px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: "600",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FaPlus /> Add Meeting
        </button>
      </div>

      {/* Add Meeting Modal */}
      {showAddMeeting && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowAddMeeting(false)}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "30px",
              maxWidth: "500px",
              width: "100%",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#2d3748", marginBottom: "20px" }}>
              Add New Meeting
            </h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                  Meeting Title *
                </label>
                <input
                  type="text"
                  value={newMeetingForm.title}
                  onChange={(e) => setNewMeetingForm({ ...newMeetingForm, title: e.target.value })}
                  placeholder="e.g., Monthly Council Meeting"
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                    Date *
                  </label>
                  <input
                    type="date"
                    value={newMeetingForm.date}
                    onChange={(e) => setNewMeetingForm({ ...newMeetingForm, date: e.target.value })}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                  />
                </div>
                <div>
                  <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                    Time *
                  </label>
                  <input
                    type="text"
                    value={newMeetingForm.time}
                    onChange={(e) => setNewMeetingForm({ ...newMeetingForm, time: e.target.value })}
                    placeholder="e.g., 10:00 AM"
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                    Type
                  </label>
                  <select
                    value={newMeetingForm.type}
                    onChange={(e) => setNewMeetingForm({ ...newMeetingForm, type: e.target.value })}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                  >
                    <option value="General">General</option>
                    <option value="Committee">Committee</option>
                    <option value="Emergency">Emergency</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>
                    Quorum Required
                  </label>
                  <input
                    type="number"
                    value={newMeetingForm.quorumRequired}
                    onChange={(e) => setNewMeetingForm({ ...newMeetingForm, quorumRequired: parseInt(e.target.value) })}
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>
              <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
                <button
                  onClick={handleAddMeeting}
                  style={{
                    flex: 1,
                    padding: "12px",
                    background: "#48bb78",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "15px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Add Meeting
                </button>
                <button
                  onClick={() => setShowAddMeeting(false)}
                  style={{
                    flex: 1,
                    padding: "12px",
                    background: "#f7fafc",
                    color: "#4a5568",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "15px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Overall Stats */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "20px",
          marginBottom: "30px",
        }}
      >
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: "14px", color: "#718096", marginBottom: "8px" }}>
            Total Meetings
          </div>
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#667eea" }}>
            {meetings.length}
          </div>
        </div>
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: "14px", color: "#718096", marginBottom: "8px" }}>
            Avg Attendance
          </div>
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#48bb78" }}>
            {Math.round(meetings.reduce((acc, m) => acc + calculateAttendanceStats(m).attendanceRate, 0) / meetings.length)}%
          </div>
        </div>
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: "14px", color: "#718096", marginBottom: "8px" }}>
            Quorum Met
          </div>
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#9f7aea" }}>
            {meetings.filter(m => calculateAttendanceStats(m).quorumMet).length}/{meetings.length}
          </div>
        </div>
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <div style={{ fontSize: "14px", color: "#718096", marginBottom: "8px" }}>
            Active Members
          </div>
          <div style={{ fontSize: "28px", fontWeight: "700", color: "#4299e1" }}>
            {memberStats.length}
          </div>
        </div>
      </div>

      {/* View Toggle */}
      <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
        <button
          onClick={() => setViewMode("list")}
          style={{
            padding: "10px 20px",
            background: viewMode === "list" ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" : "white",
            color: viewMode === "list" ? "white" : "#4a5568",
            border: "1px solid",
            borderColor: viewMode === "list" ? "#667eea" : "#e2e8f0",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FaCalendarAlt /> Meeting List
        </button>
        <button
          onClick={() => setViewMode("members")}
          style={{
            padding: "10px 20px",
            background: viewMode === "members" ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" : "white",
            color: viewMode === "members" ? "white" : "#4a5568",
            border: "1px solid",
            borderColor: viewMode === "members" ? "#667eea" : "#e2e8f0",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FaChartBar /> Member Stats
        </button>
      </div>

      {/* Meeting List View */}
      {viewMode === "list" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {meetings.map(meeting => {
            const stats = calculateAttendanceStats(meeting);
            return (
              <div
                key={meeting.id}
                style={{
                  background: "white",
                  borderRadius: "12px",
                  padding: "24px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
                  border: "1px solid #e2e8f0",
                }}
              >
                {/* Header */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
                  <div>
                    <h3 style={{ fontSize: "20px", fontWeight: "600", color: "#2d3748", margin: "0 0 8px 0" }}>
                      {meeting.title}
                    </h3>
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", fontSize: "14px", color: "#718096" }}>
                      <span>📅 {new Date(meeting.date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}</span>
                      <span>🕐 {meeting.time}</span>
                      <span style={{
                        padding: "4px 10px",
                        background: stats.quorumMet ? "#c6f6d5" : "#fed7d7",
                        color: stats.quorumMet ? "#22543d" : "#742a2a",
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}>
                        {stats.quorumMet ? "Quorum Met" : "No Quorum"}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => exportAttendanceReport(meeting)}
                    style={{
                      padding: "8px 16px",
                      background: "#f7fafc",
                      color: "#667eea",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      fontSize: "13px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <FaDownload /> Export Report
                  </button>
                </div>

                {/* Stats Bar */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                    gap: "12px",
                    marginBottom: "16px",
                    padding: "16px",
                    background: "#f7fafc",
                    borderRadius: "8px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "24px", fontWeight: "700", color: "#48bb78" }}>
                      {stats.present}
                    </div>
                    <div style={{ fontSize: "12px", color: "#718096" }}>Present</div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "24px", fontWeight: "700", color: "#f56565" }}>
                      {stats.absent}
                    </div>
                    <div style={{ fontSize: "12px", color: "#718096" }}>Absent</div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "24px", fontWeight: "700", color: "#ed8936" }}>
                      {stats.excused}
                    </div>
                    <div style={{ fontSize: "12px", color: "#718096" }}>Excused</div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "24px", fontWeight: "700", color: "#f6ad55" }}>
                      {stats.late}
                    </div>
                    <div style={{ fontSize: "12px", color: "#718096" }}>Late</div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "24px", fontWeight: "700", color: "#667eea" }}>
                      {stats.attendanceRate}%
                    </div>
                    <div style={{ fontSize: "12px", color: "#718096" }}>Rate</div>
                  </div>
                </div>

                {/* Attendance List */}
                <div>
                  <div style={{ fontSize: "14px", fontWeight: "600", color: "#2d3748", marginBottom: "12px" }}>
                    Attendance Details ({stats.total} members)
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: "8px" }}>
                    {meeting.attendance.map((record, index) => {
                      const isEditing = editingAttendance?.meetingId === meeting.id && editingAttendance?.memberId === record.memberId;
                      
                      return (
                        <div
                          key={index}
                          style={{
                            padding: "10px 12px",
                            background: isEditing ? "#fff5f5" : "#f7fafc",
                            borderRadius: "6px",
                            border: isEditing ? "2px solid #667eea" : `1px solid ${getStatusColor(record.status)}30`,
                          }}
                        >
                          {isEditing ? (
                            // Edit Mode
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                              <div style={{ fontSize: "13px", color: "#2d3748", fontWeight: "600", marginBottom: "8px" }}>
                                Editing: {record.name}
                              </div>
                              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 2fr", gap: "8px" }}>
                                <div>
                                  <label style={{ fontSize: "11px", color: "#718096", display: "block", marginBottom: "4px" }}>
                                    Status
                                  </label>
                                  <select
                                    value={editForm.status}
                                    onChange={(e) => setEditForm({ ...editForm, status: e.target.value })}
                                    style={{
                                      width: "100%",
                                      padding: "6px",
                                      border: "1px solid #e2e8f0",
                                      borderRadius: "4px",
                                      fontSize: "12px",
                                    }}
                                  >
                                    <option value="present">Present</option>
                                    <option value="absent">Absent</option>
                                    <option value="late">Late</option>
                                    <option value="excused">Excused</option>
                                  </select>
                                </div>
                                <div>
                                  <label style={{ fontSize: "11px", color: "#718096", display: "block", marginBottom: "4px" }}>
                                    Check-in Time
                                  </label>
                                  <input
                                    type="text"
                                    value={editForm.checkInTime}
                                    onChange={(e) => setEditForm({ ...editForm, checkInTime: e.target.value })}
                                    placeholder="e.g., 10:00 AM"
                                    style={{
                                      width: "100%",
                                      padding: "6px",
                                      border: "1px solid #e2e8f0",
                                      borderRadius: "4px",
                                      fontSize: "12px",
                                    }}
                                  />
                                </div>
                                <div>
                                  <label style={{ fontSize: "11px", color: "#718096", display: "block", marginBottom: "4px" }}>
                                    Reason (Optional)
                                  </label>
                                  <input
                                    type="text"
                                    value={editForm.reason}
                                    onChange={(e) => setEditForm({ ...editForm, reason: e.target.value })}
                                    placeholder="e.g., Sick leave, Conference"
                                    style={{
                                      width: "100%",
                                      padding: "6px",
                                      border: "1px solid #e2e8f0",
                                      borderRadius: "4px",
                                      fontSize: "12px",
                                    }}
                                  />
                                </div>
                              </div>
                              <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                                <button
                                  onClick={handleSaveAttendance}
                                  style={{
                                    padding: "6px 12px",
                                    background: "#48bb78",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <FaSave /> Save
                                </button>
                                <button
                                  onClick={handleCancelEdit}
                                  style={{
                                    padding: "6px 12px",
                                    background: "#f7fafc",
                                    color: "#4a5568",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "4px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <FaTimes /> Cancel
                                </button>
                              </div>
                            </div>
                          ) : (
                            // View Mode
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1 }}>
                                <div style={{ color: getStatusColor(record.status), fontSize: "14px" }}>
                                  {getStatusIcon(record.status)}
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ fontSize: "13px", color: "#2d3748", fontWeight: "500" }}>
                                    {record.name}
                                  </div>
                                  {record.checkInTime && (
                                    <div style={{ fontSize: "11px", color: "#a0aec0" }}>
                                      {record.checkInTime}
                                    </div>
                                  )}
                                  {record.reason && (
                                    <div style={{ fontSize: "11px", color: "#718096", fontStyle: "italic" }}>
                                      {record.reason}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <span
                                  style={{
                                    padding: "4px 8px",
                                    background: getStatusColor(record.status),
                                    color: "white",
                                    borderRadius: "4px",
                                    fontSize: "10px",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {record.status}
                                </span>
                                <button
                                  onClick={() => handleEditAttendance(meeting.id, record)}
                                  style={{
                                    padding: "6px 10px",
                                    background: "#667eea",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "4px",
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <FaEdit /> Edit
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Member Stats View */}
      {viewMode === "members" && (
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "24px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e2e8f0",
          }}
        >
          <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#2d3748", marginBottom: "20px" }}>
            Member Attendance Statistics
          </h2>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0 8px" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left", padding: "12px", fontSize: "13px", color: "#718096", fontWeight: "600" }}>
                    Member
                  </th>
                  <th style={{ textAlign: "center", padding: "12px", fontSize: "13px", color: "#718096", fontWeight: "600" }}>
                    Total Meetings
                  </th>
                  <th style={{ textAlign: "center", padding: "12px", fontSize: "13px", color: "#718096", fontWeight: "600" }}>
                    Present
                  </th>
                  <th style={{ textAlign: "center", padding: "12px", fontSize: "13px", color: "#718096", fontWeight: "600" }}>
                    Absent
                  </th>
                  <th style={{ textAlign: "center", padding: "12px", fontSize: "13px", color: "#718096", fontWeight: "600" }}>
                    Excused
                  </th>
                  <th style={{ textAlign: "center", padding: "12px", fontSize: "13px", color: "#718096", fontWeight: "600" }}>
                    Late
                  </th>
                  <th style={{ textAlign: "center", padding: "12px", fontSize: "13px", color: "#718096", fontWeight: "600" }}>
                    Rate
                  </th>
                  <th style={{ textAlign: "left", padding: "12px", fontSize: "13px", color: "#718096", fontWeight: "600" }}>
                    Progress
                  </th>
                </tr>
              </thead>
              <tbody>
                {memberStats.map((stat, index) => (
                  <tr key={index} style={{ background: "#f7fafc" }}>
                    <td style={{ padding: "12px", fontSize: "14px", color: "#2d3748", fontWeight: "500", borderRadius: "8px 0 0 8px" }}>
                      {stat.name}
                    </td>
                    <td style={{ textAlign: "center", padding: "12px", fontSize: "14px", color: "#2d3748" }}>
                      {stat.total}
                    </td>
                    <td style={{ textAlign: "center", padding: "12px", fontSize: "14px", color: "#48bb78", fontWeight: "600" }}>
                      {stat.present}
                    </td>
                    <td style={{ textAlign: "center", padding: "12px", fontSize: "14px", color: "#f56565", fontWeight: "600" }}>
                      {stat.absent}
                    </td>
                    <td style={{ textAlign: "center", padding: "12px", fontSize: "14px", color: "#ed8936", fontWeight: "600" }}>
                      {stat.excused}
                    </td>
                    <td style={{ textAlign: "center", padding: "12px", fontSize: "14px", color: "#f6ad55", fontWeight: "600" }}>
                      {stat.late}
                    </td>
                    <td style={{ textAlign: "center", padding: "12px", fontSize: "14px", color: "#667eea", fontWeight: "700" }}>
                      {stat.attendanceRate}%
                    </td>
                    <td style={{ padding: "12px", borderRadius: "0 8px 8px 0" }}>
                      <div style={{ width: "100%", height: "8px", background: "#e2e8f0", borderRadius: "4px", overflow: "hidden" }}>
                        <div
                          style={{
                            width: `${stat.attendanceRate}%`,
                            height: "100%",
                            background: stat.attendanceRate >= 80 ? "#48bb78" : stat.attendanceRate >= 60 ? "#ed8936" : "#f56565",
                            transition: "width 0.3s ease",
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

